import { TwoWalletEventError } from './error';
import type { CheckoutRedirects, CheckoutResult } from './types';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

export function cleanApiBaseUrl(value: string): string {
  const url = new URL(String(value));
  const localHttp = url.protocol === 'http:' && LOCAL_HOSTS.has(url.hostname);

  if (url.protocol !== 'https:' && !localHttp) {
    throw new TypeError('apiBaseUrl must use HTTPS.');
  }
  if (url.username || url.password) {
    throw new TypeError('apiBaseUrl must not contain credentials.');
  }

  url.pathname = url.pathname.replace(/\/$/, '');
  url.search = '';
  url.hash = '';
  return url.href.replace(/\/$/, '');
}

export function checkoutRedirectsFor(
  pageUrl: string | URL = globalThis.location.href,
): CheckoutRedirects {
  const url = new URL(pageUrl);
  url.search = '';
  url.hash = '';
  return { successUrl: url.href, cancelUrl: url.href };
}

export function redirectToCheckout(
  result: CheckoutResult,
  targetWindow: Window = globalThis.top ?? globalThis.window,
): void {
  let url: URL;
  try {
    url = new URL(result.checkoutUrl);
  } catch {
    throw new TwoWalletEventError('No se recibió un enlace de pago válido.');
  }

  if (url.protocol !== 'https:' || url.hostname !== 'checkout.stripe.com') {
    throw new TwoWalletEventError('No se recibió un enlace de pago válido.');
  }
  targetWindow.location.href = url.href;
}
